import { render } from "./ProjectConfig.vue?vue&type=template&id=a61dd5fa&scoped=true"
import script from "./ProjectConfig.vue?vue&type=script&lang=js"
export * from "./ProjectConfig.vue?vue&type=script&lang=js"

import "./ProjectConfig.vue?vue&type=style&index=0&id=a61dd5fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61dd5fa"]])

export default __exports__